"use strict";

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connector = void 0;

var Connector = /*#__PURE__*/function () {
  /**
   * @param actions - Methods bound to a zustand store that tracks the state of the connector.
   * @param onError - An optional handler which will report errors thrown from event listeners.
   * Actions are used by the connector to report changes in connection status.
   */
  function Connector(actions, onError) {
    _classCallCheck(this, Connector);

    this.actions = actions;
    this.onError = onError;
  }
  /**
   * Reset the state of the connector without otherwise interacting with the connection.
   */


  _createClass(Connector, [{
    key: "resetState",
    value: function resetState() {
      this.actions.resetState();
    }
  }]);

  return Connector;
}();

exports.Connector = Connector;